import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import { Swiper } from "swiper/react";
import Color from "../../../assets/colors";

export const TitleStyled = styling(Typography)((props) => ({
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "40px",
  fontFamily: "Georgia",
  fontWeight: 400,
  lineHeight: "32px",
  textAlign: "center",

  span: {
    color: Color.hiredlyPurple,
    fontSize: "40px",
    lineHeight: "32px",
    fontWeight: 400,
  },

  ...(props?.type == "subtitle" && {
    color: "rgba(0, 0, 0, 0.60)",
    fontFamily: "Inter",
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: 500,
    textAlign: "center",
  }),

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "32px",
    fontFamily: "Georgia",
    fontWeight: 400,
    lineHeight: "32px",
    textAlign: "center",

    span: {
      color: Color.hiredlyPurple,
      fontSize: "32px",
      lineHeight: "32px",
      fontWeight: 400,
    },

    ...(props?.type == "subtitle" && {
      fontFamily: "Inter",
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 500,
      textAlign: "center",
    }),
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    fontFamily: "Georgia",
    fontWeight: 400,
    lineHeight: "32px",
    textAlign: "center",

    span: {
      color: Color.hiredlyPurple,
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: 400,
    },

    ...(props?.type == "subtitle" && {
      fontFamily: "Inter",
      fontSize: "12px",
      lineHeight: "24px",
      fontWeight: 500,
      textAlign: "center",
    }),
  },
}));

export const SwiperStyled = styling(Swiper)((props) => ({
  width: "100%",
  overflow: "hidden",

  "& .swiper-wrapper": {
    transitionTimingFunction: "linear",
  },

  "& .swiper-slide": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "auto",
  },
}));

export const LogoContainer = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "80px",
  padding: "12px",
  minWidth: "144px",

  cursor: "pointer",

  [props.theme.breakpoints.down("lg")]: {
    height: "70px",
    padding: "10px",
    minWidth: "120px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: "60px",
    padding: "8px",
    minWidth: "100px",
  },
}));

export const LogoStyled = styling("img")((props) => ({
  height: "100%",
  objectFit: "contain",
  maxWidth: "120px",
  maxHeight: "60px",
  backgroundSize: "contain",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {
    maxHeight: "50px",
    maxWidth: "100px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "40px",
    maxWidth: "80px",
  },
}));

export const TitleContainer = styling(Grid)((props) => ({
  margin: "0px",

  [props.theme.breakpoints.down("tablet")]: {
    margin: "0px",
  },
}));

export const TrustedCompanyGrid = styling(Grid)((props) => ({
  padding: "80px 100px",
  gap: "30px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    gap: "20px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
    gap: "15px",
  },
}));

export const CarouselContainer = styling(Grid)((props) => ({
  // maxWidth: "1220px",
  // padding: "0px 200px",
  height: "100%",
  maxWidth: "1240px",

  [props.theme.breakpoints.down("lg")]: {
    // maxWidth: "720px",
    padding: "0px 0px",
  },

  // [props.theme.breakpoints.down("tablet")]: {
  //   maxWidth: "100%",
  // },
}));

export const CompanyButtons = styling("a")((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  borderRadius: "16px",
  border: "1px solid #D8D8D8",
  background: "#F7F7FF",
  alignContent: "center",

  "&:hover": {
    border: "1px solid #512ACC",
  },

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));
